import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import {
  TipologiaRegistrazioneDto,
  TipologiaRegistrazioneExtendedDto,
} from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { RiepilogoPerTipologia } from '@ideapa/common-utils';

@Injectable()
export class TipologiaRegistrazioneApiClient extends BaseCRUDApiClient<TipologiaRegistrazioneDto> {
  baseUrl = this.config.apiEndpoint + '/tipologia-registrazione';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getTipologiaByCode(codiceTipologia: string) {
    return this.http.post<TipologiaRegistrazioneDto>(
      this.baseUrl + '/get-tipologia-by-code',
      {
        codiceTipologia: codiceTipologia,
      }
    );
  }

  getTipologieSelezionabili() {
    return this.http.get<TipologiaRegistrazioneDto[]>(
      `${this.baseUrl}/get-tipologie-selezionabili`
    );
  }

  getCofiGroupByTipologia() {
    this._pagedCache.clear();
    return this.http.get<RiepilogoPerTipologia[]>(
      `${this.baseUrl}/cofiGroupByTipologia`
    );
  }

  getPrimaNotaGroupByTipologia() {
    this._pagedCache.clear();
    return this.http.get<RiepilogoPerTipologia[]>(
      `${this.baseUrl}/primaNotaGroupByTipologia`
    );
  }
  // getCofiGroupByTipologia() {
  //   this._pagedCache.clear();
  //   return this.http.get<TipologiaRegistrazioneExtendedDto[]>(
  //     `${this.baseUrl}/cofiGroupByTipologia`
  //   );
  // }

  // getPrimaNotaGroupByTipologia() {
  //   this._pagedCache.clear();
  //   return this.http.get<TipologiaRegistrazioneExtendedDto[]>(
  //     `${this.baseUrl}/primaNotaGroupByTipologia`
  //   );
  // }
}
